import { useEffect, useRef, useState } from "react"
import { classNames } from "../lib"
import { Tab, TabGroup, TabList } from "@headlessui/react"

const LanguageToggle = () => {
  const [selectedIndex, setSelectedIndex] = useState(0)
  const chuukBlock = useRef(document.getElementById("chuukese-translation"))
  const englishBlock = useRef(document.getElementById("english-translation"))

  const buttonBaseClass =
    "px-2.5 py-1.5 border-y border-sky-500 text-sm focus:z-10 focus:outline-none focus:ring-2"

  useEffect(() => {
    if (selectedIndex === 0) {
      chuukBlock.current?.classList.remove("hidden")
      chuukBlock.current?.classList.add("flex")
      englishBlock.current?.classList.remove("flex")
      englishBlock.current?.classList.add("hidden")
    } else {
      chuukBlock.current?.classList.remove("flex")
      chuukBlock.current?.classList.add("hidden")
      englishBlock.current?.classList.remove("hidden")
      englishBlock.current?.classList.add("flex")
    }
  }, [selectedIndex])

  return (
    <TabGroup as="div" selectedIndex={selectedIndex} onChange={setSelectedIndex} manual>
      <TabList className={classNames("absolute right-6 mt-6 inline-flex text-gray-700 rounded-md")}>
        <Tab
          className={classNames(
            buttonBaseClass,
            "rounded-l-md border-l",
            selectedIndex === 0
              ? "text-white bg-sky-500 font-bold"
              : "bg-white hover:bg-slate-100 hover:text-sky-500"
          )}
        >
          Chuukese
        </Tab>
        <Tab
          className={classNames(
            buttonBaseClass,
            "rounded-r-md border-x",
            selectedIndex === 1
              ? "text-white bg-sky-500 font-bold"
              : "hover:bg-slate-100 hover:text-sky-500"
          )}
        >
          English
        </Tab>
      </TabList>
    </TabGroup>
  )
}

export default LanguageToggle
